import React, { useMemo, useState } from "react";
import moment from "moment";
import styles from "./index.module.scss";
import Timer from "../../../stories/common/timer";
// import ReleaseBtn from "../../../stories/common/flipper-vault-card/releaseButton";
// import { formatPhoneNumber } from "../../../utils/utils";
import Buttonc from "../../../stories/common/button";
// import { useNavigate } from "react-router-dom";
// import { InvestorBidInitiated } from "../../../utils/inv-exch-amplitude";
import ContactWeb from "../../flipper-vault/web-list-view/list-row/contact-web";
import VaultTag from "../../../stories/common/vault-tag";
import AddNotesDialog from "../add-notes";
import CallRecordsDialog from "../call-records";
import InvestorDetailsSidebar from "../../../stories/common/calling-pipeline-header/investor-details-sidebar";
import CallingStatusTag from "../../../stories/common/calling-status-tag";
import { Tooltip } from "primereact/tooltip";
// import AddNotesDialog from "../add-notes";
// import CallRecordsDialog from "../call-records";

interface InvCardProps {
  id?: string;
  expiryAt: string;
  accountId: string;
  checkoutId: string;
  releasedAt: string;
  accountName: string;
  email: string;
  engmtStatus?: string;
  plainPhone: string;
  propertyId: string;
  propertySfid?: string;
  accountSfid?: string;
  address: string;
  userName?: string;
  createdAt: string;
  bidCount?: number;
  callingStatus?: string;
  portalStatus: string;
  contacts?: Array<{
    id: string;
    name: string;
    sfid: string;
    email: string;
    mobile: string;
  }>;
  callRecords?: Array<{
    callOutcome: string;
    callNotes: string;
    followupDate: string;
    cityOfInterest: string;
  }>;
}

export default function CallingPipelineWebCard({
  address,
  checkoutId,
  accountName,
  expiryAt,
  createdAt,
  releasedAt,
  email,
  plainPhone,
  accountId,
  userName,
  propertyId,
  bidCount,
  contacts,
  accountSfid,
  propertySfid,
  engmtStatus,
  portalStatus,
  callRecords,
  id
}: InvCardProps) {
  const [isExpired, setIsExpired] = useState(
    moment.utc(expiryAt).isBefore(moment().utc())
  );
  const [visible, setVisibleNotes] = useState(false);
  const [visibleInvDetail, setVisibleInvDetail] = React.useState(false);
  const [visibleCallRecords, setVisibleCallRecords] = useState(false);

  const cityOfInterestRaw = callRecords?.[0]?.cityOfInterest || "";
  const cities = useMemo(
    () =>
      (cityOfInterestRaw || "")
        .split(",")
        .map((c: string) => c.trim())
        .filter((c: string) => c.length > 0),
    [cityOfInterestRaw]
  );
  const visibleCitiesText = useMemo(
    () => cities.slice(0, 2).join(", "),
    [cities]
  );
  const remainingCities = useMemo(() => cities.slice(2), [cities]);

  const vaultStatus = useMemo(() => {
    if (releasedAt !== null) {
      return "RELEASED";
    } else if (isExpired && releasedAt === null) {
      return "EXPIRED";
    } else {
      return "CHECKED OUT";
    }
  }, [releasedAt, isExpired]);

  return (
    <>
      <AddNotesDialog
        visible={visible}
        setVisible={setVisibleNotes}
        placeholder="Add notes..."
        heading="Add Notes"
        accountId={accountId}
        propertyId={propertyId}
        isEdit={false}
      />
      <CallRecordsDialog
        visible={visibleCallRecords}
        setVisible={setVisibleCallRecords}
        accountId={accountId}
        propertyId={propertyId}
        checkoutId={checkoutId}
      />
      <InvestorDetailsSidebar
        visibleInvDetail={visibleInvDetail}
        setVisibleInvDetail={setVisibleInvDetail}
        setVisibleNotes={setVisibleNotes}
        setVisibleCallRecords={setVisibleCallRecords}
        accountId={accountId}
        propertyId={propertyId}
        checkoutId={checkoutId}
      />
      <div
        className={styles.invCardWrapper}
        onClick={() => {
          setVisibleInvDetail(true);
        }}
      >
        <div className={styles.invCardDetails}>
          <div className={styles.AccName}>{accountName}</div>
          <div className={styles.AccAddress}>{address}</div>
          {cities.length > 0 && (
            <div className={styles.cityOfInterest}>
              <img
                src="/images/city-of-inst.svg"
                alt=""
                width={20}
                height={20}
              />
              <span className={styles.cityText}>
                City of Interest:{" "}
                <span className={styles.cityName}>
                  {visibleCitiesText}
                  {remainingCities.length > 0 && (
                    <>
                      {" "}
                      <span
                        className={`tooltip-${accountId}-${propertyId}`}
                        style={{ cursor: "pointer" }}
                      >
                        +{remainingCities.length}
                      </span>
                      <Tooltip
                        target={`.tooltip-${accountId}-${propertyId}`}
                        content={`${remainingCities?.join(", ")}`}
                        className={styles.tooltip}
                      />
                    </>
                  )}
                </span>
              </span>
            </div>
          )}
        </div>
        <div className={styles.contactInfo}>
          {vaultStatus === "CHECKED OUT" ? (
            <ContactWeb
              account={{
                contacts: contacts,
                acctSfid: accountSfid,
                acctId: accountId,
                propertyId: propertyId,
                propertySfid: propertySfid
              }}
            />
          ) : (
            "-"
          )}

          {callRecords !== null && callRecords?.[0]?.followupDate && (
            <>
              {moment
                .utc(callRecords?.[0]?.followupDate)
                .local()
                .isBefore(moment()) ? (
                <span className={styles.followupDue}>Follow-up Due</span>
              ) : (
                <span className={styles.followupScheduled}>
                  Follow-up Scheduled on{" "}
                  {moment
                    .utc(callRecords?.[0]?.followupDate)
                    .local()
                    .format("MMM Do")}
                </span>
              )}
            </>
          )}
        </div>
        <div className={styles.notes}>
          {callRecords?.[0]?.callNotes && (
            <>
              <div className={styles.callNotes}>
                {callRecords?.[0]?.callNotes?.length > 50
                  ? callRecords?.[0]?.callNotes?.slice(0, 50) + "..."
                  : callRecords?.[0]?.callNotes}
              </div>
              <div className={styles.viewAll}>View All</div>
            </>
          )}
        </div>
        <div className={styles.tagsWrap}>
          {callRecords?.[0]?.callOutcome ? (
            <CallingStatusTag
              callingStatus={callRecords?.[0]?.callOutcome || null}
            />
          ) : (
            <VaultTag status={vaultStatus} isLocked={false} />
          )}
        </div>
        <div className={styles.TimerWrapper}>
          {!isExpired && expiryAt && releasedAt === null && (
            <Timer
              className={styles.Timer}
              acctId={accountId}
              time={expiryAt}
              onExpire={() => {
                setIsExpired(true);
              }}
              createdAt={createdAt}
              classNameTitle={styles.TimerTitle}
              classNameClock={styles.classNameClock}
            />
          )}
        </div>
        <div className={styles.btnWrap}>
          <Buttonc
            type="button"
            disabled={vaultStatus === "RELEASED" || vaultStatus === "EXPIRED"}
            className={styles.addNotes}
            icon={<img src="/images/add-notes.svg" alt="add-notes" />}
            onClick={(e: any) => {
              e.stopPropagation();
              setVisibleNotes(true);
            }}
          />
          <Buttonc
            type="button"
            className={styles.addNotes}
            disabled={vaultStatus === "RELEASED" || vaultStatus === "EXPIRED"}
            btnType="border"
            icon={<img src="/images/call-agent.svg" alt="add-notes" />}
            onClick={(e: any) => {
              e.stopPropagation();
              setVisibleCallRecords(true);
            }}
          />
        </div>
      </div>
    </>
  );
}
